import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Filter } from "iconoir-react";
import MainLayout from "../layouts/MainLayout";
import { Outlet, useLocation, useNavigate } from "react-router";
import { memo, useEffect, useState } from "react";
import Message from "../components/common/Message";
import { ACL_ACTION_TYPE } from "../utils/constants";
import { inject, observer } from "mobx-react";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box className="pt-2 ">
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const DocumentPage = ({ aclStore }) => {
    const [value, setValue] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();
    const [openMessage, setOpenMessage] = useState(false);
    useEffect(() => {
        if (location.pathname === "/internal-document/outgoing-document") {
            setValue(1);
        } else if (
            location.pathname === "/internal-document/incoming-document"
        ) {
            setValue(0);
        }
    }, [location]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue === 0) {
            navigate("incoming-document");
        } else if (newValue === 1) {
            navigate("outgoing-document");
        }
    };
    return (
        <MainLayout initialValue={2}>
            <div className="px-5">
                <div className="flex justify-between items-center mb-[16px]">
                    <div className="font-bold text-[28px] leading-[29px]  ">
                        Văn bản nội bộ
                    </div>
                    <span
                        className="w-5 cursor-pointer"
                        onClick={() => {
                            setOpenMessage(true);
                        }}
                    >
                        <Filter />
                    </span>
                </div>
                <Box className="" sx={{ width: "100%" }}>
                    <Box sx={{}}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="basic tabs example"
                        >
                            {aclStore.checkAccessControlAction(
                                ACL_ACTION_TYPE.tab_vb_den__INTERNAL_DOCUMENT
                            ) && (
                                <Tab
                                    className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                                    label="Văn bản đến"
                                    {...a11yProps(0)}
                                />
                            )}
                            {aclStore.checkAccessControlAction(
                                ACL_ACTION_TYPE.tab_vb_di__INTERNAL_DOCUMENT
                            ) && (
                                <Tab
                                    className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0"
                                    label="Văn bản đi"
                                    {...a11yProps(1)}
                                />
                            )}
                        </Tabs>
                    </Box>
                    {/* <TabPanel value={value} index={0}>
                        <InternalDocumentIncoming />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <InternalDocumentOutgoing/>
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        Item Three
                    </TabPanel> */}
                    <TabPanel>
                        <Outlet />
                    </TabPanel>
                </Box>
            </div>
            <Message
                message="Tính năng đang phát triển"
                openMessage={openMessage}
                closeMessage={() => {
                    setOpenMessage(false);
                }}
            />
        </MainLayout>
    );
};

export default memo(inject("aclStore")(observer(DocumentPage)));
